<template>
  <el-dialog custom-class="medium-dialog" title="扫码出库" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true"  :before-close="handleClose">
    <div class="search-content">
      <div v-if="supplytaskid">{{this.controlData.billmap?this.controlData.billmap[0].seedcode:''}}&nbsp;&nbsp;{{this.controlData.billmap?this.controlData.billmap[0]["产品名称"]:''}}
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" class="query-table">
        <tr>
          <td style="text-align: center;width: 60px">序号</td>
          <td style="text-align: center;width:100px;">R/L</td>
          <td style="text-align: center;width:140px;" >规格</td>
          <td style="text-align: center;width:200px;">商品条码</td>
          <td style="text-align: center;width:300px;">{{noscan?'出库数量':'唯一码'}}</td>
        </tr>
        <tr v-for="(item,i) in scancodes">
          <td>{{i+1}}</td>
          <td class="left">{{item["R/L"]}}</td>
          <td>{{getPackagesize(item.packagesize)}}</td>
          <td class="left"><input v-model="item.goodsbarcode" style="width: 90%" onfocus="this.select()" @change="replaceItemCode(item,'goodsbarcode')"/></td>
          <td style="text-align: right;"><input v-model="item.storegoodsbarcode" style="width: 90%" onfocus="this.select()" @change="replaceItemCode(item,'storegoodsbarcode')"/></td>
        </tr>
      </table>
      </div>
      <div v-else-if="codeInURL">
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" class="query-table">
        <tr>
        <td style="text-align: center;width: 60px">序号</td>
        <td style="text-align: center;width:140px;" >规格</td>
        <td style="text-align: center;width:140px;">数量</td>
        <td style="text-align: center;width:140px;">已扫</td>
        </tr>
        <tr v-for="(item,i) in pagesizeTable">
        <td>{{i+1}}</td>
        <td>{{item.sc}}</td>
        <td style="text-align: right;">{{item.num}}</td>
        <td style="text-align: right;color: red" v-if="item.scannum<item.num">{{item.scannum>0?item.scannum:''}}</td>
        <td style="text-align: right;" v-else>{{item.scannum>0?item.scannum:''}}</td>
        </tr>
        </table>
        <!--<table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" class="query-table">-->
          <!--<tr>-->
            <!--<td style="text-align: center;width: 60px">序号</td>-->
            <!--<td style="text-align: center;width:140px;" >规格</td>-->
            <!--<td style="text-align: center;width:220px;">唯一码</td>-->
          <!--</tr>-->
          <!--<tr v-for="(item,i) in scancodes">-->
            <!--<td>{{i+1}}</td>-->
            <!--<td>{{item.showpg}}</td>-->
            <!--<td style="text-align: right;">{{item.storegoodsbarcode}}-->
            <!--</td>-->
          <!--</tr>-->
        <!--</table>-->
      </div>
      <div v-else>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" class="query-table">
        <tr>
          <td style="text-align: center;width: 60px">序号</td>
          <td style="text-align: center;">名称</td>
          <td style="text-align: center;width:140px;" >规格</td>
          <td style="text-align: center;width:220px;">{{noscan?'出库数量':'唯一码'}}</td>
          <td style="text-align: center;width:120px;">批次号</td>
          <td style="text-align: center;width:120px;">有效期</td>
        </tr>
        <tr v-for="(item,i) in scancodes">
          <td>{{i+1}}</td>
          <td class="left">{{item.seedname}}</td>
          <td>{{item.showpg}}</td>
          <td style="text-align: right;">{{item.storegoodsbarcode}}
            <!--<input v-model="" style="width: 90%" onfocus="this.select()" @change="replaceItemCode(item,'storegoodsbarcode')"/>-->
          </td>
          <td style="text-align: center;">{{item.batchno}}</td>
          <td style="text-align: center;">{{item.endtime}}</td>
        </tr>
      </table>
    </div>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <span v-if="scanNum>0" ><span style="color: red;font-weight: bolder">{{scanNum}}</span>/{{scancodes.length}}</span>
      <el-button @click="hideDialog(false)">取 消</el-button>
      <el-button type="success" @click="buyOrderQrcode" :loading="loading" v-if="dmscode&&!supplytaskid&&controlData.buyerpserial&&controlData.qrcodescan">打码</el-button>
      <el-button type="primary" @click="saveData" :loading="loading" v-if="dmscode">确定发货</el-button>
      <el-button type="warning" @click="importFrombuy" :loading="loading" size="mini" v-if="dmscode&&supplytaskid">从采购导入</el-button>
      <el-input style="width: 130px" size="small" v-if="issale&&noscan" v-model="goodsbarcode" placeholder="扫商品条码" onfocus="this.select()" @keyup.enter.native="selectbarcode()"></el-input>
      <el-input style="width: 130px" ref="inputScan" size="small" v-if="issale&&!noscan&&!supplytaskid" v-model="storegoodsbarcode" placeholder="扫唯一码"  onfocus="this.select()" @keyup.enter.native="getZyanjingQRCode()"></el-input>
      <el-input style="width: 130px" ref="inputScan" size="small" v-if="issale&&!noscan&&supplytaskid" v-model="storegoodsbarcode" placeholder="扫唯一码"  onfocus="this.select()" @keyup.enter.native="getBarCode()"></el-input>
      <el-input style="width: 130px" size="small" v-if="issale&&!noscan&&supplytaskid" v-model="storegoodsbarcode" placeholder="核对唯一码" onfocus="this.select()" @keyup.enter.native="chechBarCode()"></el-input>
      <OrderBuyList ref="orderbuyList" @select="selectData"></OrderBuyList>
    </div>
    <el-dialog title="输入" :append-to-body="true" :visible.sync="childdialogVisible" width="30%" height="300px">
        <el-radio-group v-model="printstatus" size="mini">
          <el-radio label="">首行不空</el-radio>
          <el-radio label="1">首行空1格</el-radio>
          <el-radio label="2">首行空2格</el-radio>
        </el-radio-group>
      <span slot="footer" class="dialog-footer">
    <el-button @click="childdialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="handleDia">确 定</el-button>
  </span>
    </el-dialog>
  </el-dialog>
</template>
<script>
  import {getlistSimp} from '@/api/set/certmanage'
  import {listData,detailStoregoodsbarcode,updateouttime} from '@/api/set/jxcstoregoodsbarcode';
  import {listBar,batchSave,printBar,getQRCode,updateouttime as updateQRouttime,checkBars} from '@/api/set/jxcstoregoodsbar';
  import {bardetail} from '@/api/set/jxcgoodsbarcode';
  import OrderBuyList from '@/components/voucher/OrderBuyList';
  import {getGoBack,orderStore,getLogisticCode} from '@/api/ossi'

  export default {
    name: "ScanCodeSupplyer",
    data() {
      return {
        isshowqr: false,
        noscan:false,
        loading:false,
        issale: false,
        scancodes: [],
        scanNum:0,
        ordertype:'',
        posttxt:{},
        storegoodsbarcode: '',
        childdialogVisible:false,
        printstatus:"",
        goodsbarcode:'',
        pcustomerserial:'',
        dmscode:'',
        checkcodes:false,
        supplytaskid:'',
        certs: [],
        dialogFormVisible: false,
        postSuplyData:{},
        saletype:'',
        controlData:{},
        buyerpserial:'',
        buyBarscode:[],
        needsaveQR:false,
        needsaveQRCode:'',
        codeInURL:false,
        pagesizeTable:[],
      }
    },
    methods: {
      handleClose(done) {
        this.save2IEStore(false);
        done();
      },
      hideDialog(haspost) {
        this.save2IEStore(haspost);
        this.dialogFormVisible = false;
      },
      save2IEStore(haspost){
      },
      replaceItemCode(item,cols) {
        item[cols] = this.replaceCode(item[cols]);
      },
      parseStr(str){
        var result = '';
        for(var i= 0;i<str.length;i++){
          var temp = str.charAt(i);
          var code = temp.charCodeAt();
          if('a' <= temp && temp <= 'z'){
            temp= String.fromCharCode(code-32);
          } else if('A' <= temp && temp <= 'Z'){
            temp= String.fromCharCode(code+32);
          }

          result += temp;
        }
        return result;
      },
      replaceCode(str){
        if(str.indexOf('HTTP')>-1){
          str=this.parseStr(str);
        }
        if(str.indexOf('?')>-1){
          str=str.substr(str.lastIndexOf('?')+1);
        }
        if(str.indexOf('/')>-1){
          str=str.substr(str.lastIndexOf('/')+1);
        }
        return str;
      },
      importFrombuy(){
        this.$refs.orderbuyList.show(this.controlData.billmap[0].seedcode,this.controlData.cangkucode,true);
      },
      selectData(rows,erpserial) {
        this.buyerpserial=erpserial;
        this.loading=true;
        for (let i in this.scancodes) {
          var item = this.scancodes[i];
          if (item.storegoodsbarcode)
            continue;

          var first = rows.find(o => !o.use && o.packagesize == item.packagesize);

          if (first) {
            first.use = true
            item.storegoodsbarcode=first.storegoodsbarcode;
            item.goodsbarcode=first.goodsbarcode;
          }
        }
        this.loading=false;

        //批量推送唯一码
        // this.saveData();
      },
      getBarCode() {
        var barcode = this.replaceCode(this.storegoodsbarcode);
        this.storegoodsbarcode = ''
        detailStoregoodsbarcode({storegoodsbarcode: barcode}).then(response => {
          if (response.data.code == 0 && response.data.obj) {
            var arr = response.data.obj;

            for (let j in this.scancodes) {
              if (this.scancodes[j].storegoodsbarcode)//有编码的继续
                continue;
              if (this.scancodes[j].packagesize == arr.packagesize && this.scancodes[j].seedcode == arr.seedcode) {
                this.scancodes[j].goodsbarcode = arr.goodsbarcode;
                this.scancodes[j].storegoodsbarcode = barcode;
                barcode = '';
                break;
              }
            }

            if (barcode) {
              this.error('未匹配到商品！')
            }
          } else {
            this.error('条码不存在！')
          }
        });
      },
      getZyanjingQRCode() {//平台自己生成的二维码
        if(!this.storegoodsbarcode) return;
        this.storegoodsbarcode=this.storegoodsbarcode.toString().replace(/……/g,'^');
        var val=this.storegoodsbarcode;
        var lowval=this.storegoodsbarcode.toLowerCase();
        if(lowval.indexOf('?')>-1&&lowval.indexOf('sn=')>-1&&lowval.indexOf('s=')>-1&&lowval.indexOf('c=')>-1){
          this.getZyanjingQRCodeinURL(val);
          this.storegoodsbarcode = '';
          return;
        }
        var qrcodeLen = this.storegoodsbarcode.split('^');
        var qrcode = qrcodeLen[qrcodeLen.length - 1]
        this.storegoodsbarcode = '';
        getQRCode({storegoodsbarcode: qrcode}).then(response => {
          if (response.data.code == 0 && response.data.obj) {
            var arr = response.data.obj;
            if (arr.used == 1) {
              this.errorAlert('商品【' + qrcode + '】已出库：' + arr.outordernum + '！');
              return;
            }
            // if (arr.endtime && new Date(arr.endtime) < new Date()) {
            //   this.errorAlert('商品【' + qrcode + '】已过期：' + arr.endtime + '！');
            //   return;
            // }
            if(this.controlData.cangkucode!=arr.cangkucode) {
              this.errorAlert('商品【' + qrcode + '】所属仓库不正确！');
              return;
            }

            var pipei = null;
            for (let j in this.scancodes) {
              if (this.scancodes[j].storegoodsbarcode)//有编码的继续
              {
                if (this.scancodes[j].storegoodsbarcode == qrcode) {
                  this.error('重复扫码【' + qrcode + '】！')
                  return;
                }
                continue;
              }

              if (pipei == null && this.scancodes[j].packagesize == arr.packagesize && (this.scancodes[j].seedcode == arr.seedcode||this.scancodes[j].subseedcode==arr.seedcode)) {
                pipei = this.scancodes[j];
              }
            }

            if (!pipei) {
              this.errorAlert('未匹配到商品！')
            } else {
              this.scanNum+=1;
              pipei.storegoodsbarcode = qrcode;
              pipei.batchno = this.formatDate(arr.starttime);
              pipei.endtime = this.formatDate(arr.endtime);
            }
          } else {
            this.errorAlert('条码【' + qrcode + '】不存在！')
          }
        });
      },
      getZyanjingQRCodeinURL(val) {
        if (!val) return;
        //http://verify.hoya100.com.cn/verify/?sn=9984231284050888&s=-0.00&c=-0.00

        var param = val.split('?')[1].split('&');
        var sn = '';
        var x = '';
        var y = '';
        for (let key in param) {
          if (param[key].indexOf('sn=') > -1) {
            sn = param[key].replace('sn=', '');
          } else if ((param[key].indexOf('s=') > -1 || param[key].indexOf('S=') > -1)) {
            y = parseFloat(param[key].replace('s=', '').replace('S=', '')).toFixed(2);
          } else if ((param[key].indexOf('c=') > -1 || param[key].indexOf('C=') > -1)) {
            x = parseFloat(param[key].replace('c=', '').replace('C=', '')).toFixed(2);
          }
        }
        if(!sn||sn==''){
          alert('未获取到条码！'+val);
          return;
        }
        var pagsize = '{"X":"' + x + '","Y":"' + y + '"}';
        this.onlyonecode = '';
        var hasValue = null;
        for (let i in this.scancodes) {
          var item = this.scancodes[i];
          if (item.storegoodsbarcode) {
            if (item.storegoodsbarcode == sn) {
              alert('重复扫码！');
              return;
            }
            continue;
          }
          if (item.packagesize == pagsize) {
            hasValue = item;
            break;
          }
        }
        if (!hasValue) {
          alert('未匹配到光度！');
        } else {
          hasValue.storegoodsbarcode = sn;
          this.codeInURL=true;
          this.scanNum+=1;
          for(let i in this.pagesizeTable){
            if(this.pagesizeTable[i].scannum>= this.pagesizeTable[i].num)continue;
            if(this.pagesizeTable[i].sc==hasValue.showpg){
              this.pagesizeTable[i].scannum+=1;
              break;
            }
          }
          // this.$message({message: '扫码成功', type: 'success'});
        }
        return;
      },
      chechBarCode(){
        if(!this.checkcodes){
          this.checkcodes=true;
          for(let i in this.scancodes){
            this.scancodes[i].supplybarcode=this.scancodes[i].storegoodsbarcode;
            this.scancodes[i].storegoodsbarcode='';
          }
        }

        var barcode = this.storegoodsbarcode;
        this.storegoodsbarcode = ''
        var hasValue=false;
        for(let i in this.scancodes){
          if(this.scancodes[i].supplybarcode==barcode){
            this.scancodes[i].storegoodsbarcode=barcode;
            hasValue=true;
            break;
          }
        }

        if(!hasValue)
          this.error('唯一码和依视路推送的编码不一致！')
      },
      selectbarcode() {//商品光度码
        if (!this.goodsbarcode)
          return;

        var obj = {
          barcode: this.goodsbarcode
        }
        this.goodsbarcode = '';
        bardetail(obj).then(response => {
          this.goodsbar = response.data.obj
          //商品不存在提示
          if (this.goodsbar == undefined) {
            this.$message({message: '条码无效！', type: 'error'})
            return
          }
          if (this.goodsbar.seedcode != this.scancodes[0].seedcode) {
            this.$message({message: '商品不正确！', type: 'error'})
            return
          }
          var hasV=false;
          for (let i in this.scancodes) {
            if (!this.scancodes[i].goodsbarcode && this.scancodes[i].packagesize == this.goodsbar.packagesize) {
              this.scancodes[i].goodsbarcode = this.goodsbar.barcode;
              if (this.noscan)
                this.scancodes[i].storegoodsbarcode = 1;
              hasV = true;
              break;
            }
          }
          if(!hasV){
            this.$message({message: '条码无法匹配！', type: 'error'})
          }
        })
      },
      getPackagesize(Packagesize) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);
        var rl = '';
        if (ps.type)
          rl = ps.type + '，';
        if (ps.M) {
          return ps.M + '/' + ps.C.replace('/', '');
        }

        return rl + 'S：' + ps.Y + '，C：' + ps.X;
      },
      error(msg, id) {
        this.$message({
          message: msg,
          type: 'error'
        })
        if (id)
          this.$refs[Object.keys(this.$refs)[id]].focus();
      },
      errorAlert(msg){
        this.$alert(msg, '异常', {
          confirmButtonText: '确定',
          type: 'error',
          callback: action => {
            this.$refs.inputScan.focus();
          }
        });
      },
      saveDataZyanj() {//找眼镜自己的码出库
        var codes = ''
        var arr=[]
        for (let i in this.scancodes) {
          var store = this.scancodes[i].storegoodsbarcode;
          if (store) {
            if ((';' + codes).indexOf(';' + store + ';') > -1) {
              this.error('条码【' + store + '】重复！')
              this.loading = false
              return
            }
            codes += store + ";";
            arr.push(this.scancodes[i]);
          }
        }
        if (codes == '') {
          this.error('缺失条码数据！')
          this.loading = false
          return
        }
        if(this.codeInURL){//存在路径里的唯一码
          this.needsaveQR=false;
          this.dialogFormVisible = false;
          this.$emit("scancodeedit", arr);
        }else{
          checkBars({storegoodsbarcodes:codes}).then(response=>{//先检查唯一码是否存在
            if (response.data.code == 0) {//检查成功
              this.needsaveQR=true;
              this.needsaveQRCode=codes;
              this.dialogFormVisible = false;
              this.$emit("scancodeedit", arr);
            }else{
              this.error(response.data.msg)
              this.loading=false;
            }
          });
        }
      },
      saveQRCode() {
        if (!this.needsaveQR||!this.needsaveQRCode) {
          return;
        }
        this.needsaveQR = false;
        updateQRouttime({
          storegoodsbarcodes: this.needsaveQRCode,
          outordernum: this.controlData.erpserial
        }).then(response => {});
      },
      saveData() {//依视路 扫码出库
        var tracking_number_dict = {};
        this.buyBarscode = []
        this.loading = true
        //判断唯一码是否唯一
        if (this.scancodes.length == 0) {
          if (this.ordertype == 'GeneralOrder') {//一般订单 直接做出库
            var items = this.posttxt.Head.Items
            for (let i in items) {
              tracking_number_dict[items[i].ItemCode] = items[i].ItemQuantity;
            }
            this.postTot(tracking_number_dict);
            return
          }
          else {
            this.error('缺失扫码数据！')
            this.loading = false
            return
          }
        }

        if(this.dmscode=='zyanjingQRCode'){
          this.saveDataZyanj();
          return;
        }
        var type = this.supplyBack.type;//定制片buy&sale；

        var scancodelist = this.scancodes
        var hasStore = false;
        for (let i in scancodelist) {
          var storcode = scancodelist[i].storegoodsbarcode.toString();
          if (storcode && (storcode.length > 5 ||
            (storcode.length <= 5 && parseInt(storcode) > 0))) {
            hasStore = true
            // this.error('唯一码必填', scancodelist[i].id)
            // return
          } else {
            if (this.controlData.allscan) {
              this.error('唯一码不能缺失！', scancodelist[i].id)
              this.loading = false
              return
            }
            continue;//不处理
          }
          // for (let j in this.scancodes) {
          //   if (scancodelist[i].id != this.scancodes[j].id && scancodelist[i].storegoodsbarcode == this.scancodes[j].storegoodsbarcode) {
          //     this.error('唯一码重复' + scancodelist[i].storegoodsbarcode, scancodelist[i].id)
          //     this.loading=false
          //     return
          //   }
          // }

          if (this.ordertype != 'PieceLensOrder') {//批量单
            if (!scancodelist[i].goodsbarcode && this.supplytaskid != 'essilordzcangku') {
              this.error('商品条码必填')
              this.loading = false
              return
            }


            var hasValue = false;
            for (let key in tracking_number_dict) {
              if (key == scancodelist[i].goodsbarcode) {
                hasValue = true;
                if (this.noscan) {
                  tracking_number_dict[key] = tracking_number_dict[key] + 1;
                } else {
                  tracking_number_dict[key].push(scancodelist[i].storegoodsbarcode)
                }
              }
            }
            if (!hasValue) {
              var side = []
              side.push(scancodelist[i].storegoodsbarcode)
              tracking_number_dict[scancodelist[i].goodsbarcode] = this.noscan ? 1 : side;
            }

          } else {//定制片

            var hasValue = false;
            if (scancodelist[i]["R/L"]) {
              for (let key in tracking_number_dict) {
                if (key == scancodelist[i]["R/L"]) {
                  hasValue = true;
                  tracking_number_dict[key].push(scancodelist[i].storegoodsbarcode)
                }
              }
              if (!hasValue) {
                var side = []
                side.push(scancodelist[i].storegoodsbarcode)
                tracking_number_dict[scancodelist[i]["R/L"]] = this.noscan ? 1 : side;
              }
            } else {//最多2条记录
              var side = []
              side.push(scancodelist[i].storegoodsbarcode)
              if (i == 0) {
                tracking_number_dict['R'] = this.noscan ? 1 : side;
              } else {
                tracking_number_dict['L'] = this.noscan ? 1 : side;
              }
            }
          }

          if (this.buyerpserial)
            this.buyBarscode.push(scancodelist[i].storegoodsbarcode)
        }
        if (!hasStore) {
          this.error('请填写唯一码！')
          this.loading = false
          return
        }

        this.postTot(tracking_number_dict);
      },
      postTot(tracking_number_dict) {
        var trackingData = {
          params: {
            data: {
              nba_reference: this.dmscode,
              replace: true,
              tracking_number_dict: tracking_number_dict
            }
          }
        };
        if (this.supplyBack.type == 'sale') {
          trackingData.params.data["cancel_backorder"] = false;
        }
        //console.log(trackingData)
        this.postSuplyData = {
          saleout: JSON.stringify(trackingData),
          taskid: this.supplytaskid,
          pcustomerserial: this.pcustomerserial,
          erpserial: this.controlData.erpserial
        };
        this.postPurchaseIn();
      },
      postPurchaseIn() {//出入库
        if (this.supplytaskid == 'essilordzcangku') {//定制片通知仓库的模式，不需要提交到依视路
          this.hideDialog(true);//推送 成功需要删除缓存
          this.$emit("scancodeedit", this.scancodes);
          return;
        }

        orderStore(this.postSuplyData).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: response.data.msg,
              type: 'success'
            })
            this.hideDialog(true);//推送 成功需要删除缓存
            this.outtime();
            this.$emit("scancodeedit", this.scancodes);
          } else {
            var userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
            // if (userInfoModel.tenantid == 'e5682784-dbb7-4eba-939f-4c265092db1d') {
            this.$confirm(response.data.msg.replace('None', ''), '提示', {
              confirmButtonText: '继续办结此订单',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.hideDialog(true);//推送 成功需要删除缓存
              this.outtime();
              this.$emit("scancodeedit", this.scancodes);
            }).catch(() => {
              this.loading = false;
            });
            // } else {
            //   this.error(response.data.msg.replace('None', ''));
            //   this.loading = false;
            // }
          }
        });
      },
      outtime(){
        if (this.buyerpserial && this.buyBarscode.length > 0) {
          updateouttime({
            inordernum: this.buyerpserial,
            storegoodsbarcodes: JSON.stringify(this.buyBarscode)
          }).then(response => {
          });
        }
      },
      buyOrderQrcode() {
        listBar({inordernum: this.controlData.buyerpserial}).then(response => {
          var scancodes = response.data.obj.rows;
          if (scancodes.length == 0) {
            var saveitem=[];
            for (let i in this.scancodes) {
              this.scancodes[i].storegoodsbarcode = '';
              saveitem.push({
                inordernum: this.controlData.buyerpserial,
                cangkucode: this.controlData.cangkucode,
                seedcode: this.scancodes[i].subseedcode ? this.scancodes[i].subseedcode : this.scancodes[i].seedcode,
                seedname: this.scancodes[i].seedname,
                packagesize: this.scancodes[i].packagesize,
                number: 1
              })
            }
            batchSave({formdetails: JSON.stringify(saveitem)}).then(resOrder => {
              //保存后重新获取
              listBar({inordernum: this.controlData.buyerpserial}).then(res2 => {
                this.setBuyOrderQrcode(res2.data.obj.rows);
              });
            });
          } else {
            this.setBuyOrderQrcode(scancodes);
          }
        }).catch((error) => {
          console.log(error);
        });
      },
      setBuyOrderQrcode(goodsbars) {
        for (let j in goodsbars) {
          var arr = goodsbars[j];
          for (let j in this.scancodes) {
            if (this.scancodes[j].storegoodsbarcode) {
              continue;
            }
            if (this.scancodes[j].packagesize == arr.packagesize && (this.scancodes[j].seedcode == arr.seedcode || this.scancodes[j].subseedcode == arr.seedcode)) {
              var pipei = this.scancodes[j];
              pipei.storegoodsbarcode = arr.storegoodsbarcode;
              pipei.batchno = this.formatDate(arr.starttime);
              pipei.endtime = this.formatDate(arr.endtime);
              break;
            }
          }
        }
        this.childdialogVisible = true;
      },
      handleDia() {
          printBar(this.controlData.buyerpserial, this.printstatus);
          this.childdialogVisible = false;
      },
      show(controlData, scan, isshowqr) {
        this.needsaveQR=false;
        this.noscan = false
        this.loading = true;
        this.controlData = controlData;
        this.dmscode = ''
        this.issale = controlData.issale;
        this.pcustomerserial = controlData.pcustomerserial;
        this.supplytaskid = controlData.supplytaskid;
        this.ordertype = ''
        this.checkcodes = false
        this.codeInURL=false;
        this.scanNum=0;

        this.supplyBack = {}
        this.isshowqr = isshowqr;
        this.dialogFormVisible = true;
        if (!isshowqr) {
          listData({inordernum: controlData.erpserial}).then(response => {
            this.scancodes = response.data.obj
            for(let i in this.scancodes){
              this.scancodes[i].showpg=this.getPackagesize(this.scancodes[i].packagesize)
              //商品名称：jxcstoregoodsbarcode表可能没存seedname，从销售订单商品明细(billmap)按seedcode过滤填充
              if ((!this.scancodes[i].seedname || this.scancodes[i].seedname == '') && controlData.billmap && controlData.billmap.length > 0 && this.scancodes[i].seedcode) {
                for (let b in controlData.billmap) {
                  var bm = controlData.billmap[b];
                  if (bm && bm.seedcode && bm.seedcode == this.scancodes[i].seedcode) {
                    this.scancodes[i].seedname = bm['产品名称'];
                    break;
                  }
                }
              }
            }
          });
          return;
        }

        var scancodes = [];//JSON.parse(JSON.stringify(scan))
        this.scancodes = scancodes;
        this.pagesizeTable=[]

        var index = 0;
        if (controlData.batchbarcode) {
          for (let j in controlData.batchbarcode) {
            controlData.batchbarcode[j].hasuse = false;
          }
        }

        if (this.controlData.billmap[0]["产品名称"].indexOf("微星") == 0) {
          this.noscan = true;
        }

        for (let i in controlData.billmap) {
          if (!controlData.billmap[i]["packagesize"])
            continue;

          var showpg=this.getPackagesize(controlData.billmap[i]["packagesize"]);
          this.pagesizeTable.push({sc:showpg,num:controlData.billmap[i]['数量'],scannum:0});

          for (var j = 0; j < controlData.billmap[i]['数量']; j++) {
            if (controlData.billmap[i]["产品名称"] == "合计")
              continue;

            var storegoodsbarcode = '';
            var goodsbarcode = '';
            if (!this.noscan && controlData.batchbarcode) {
              for (let j in controlData.batchbarcode) {
                if (!controlData.batchbarcode[j].hasuse && controlData.batchbarcode[j].packagesize == controlData.billmap[i]["packagesize"]) {
                  storegoodsbarcode = controlData.batchbarcode[j].storegoodsbarcode;
                  goodsbarcode = controlData.batchbarcode[j].goodsbarcode;
                  controlData.batchbarcode[j].hasuse = true;
                  break;
                }
              }
            }

            var pg=JSON.parse(controlData.billmap[i]["packagesize"]);
            scancodes.push({
              "seedname": controlData.billmap[i]["subseedcode"] ? controlData.billmap[i]["关联产品"] : controlData.billmap[i]["产品名称"],
              "seedcode": controlData.billmap[i]["seedcode"],
              "subseedcode": controlData.billmap[i]["subseedcode"] ,
              "erpserial": controlData.erpserial,
              "packagesize": controlData.billmap[i]["packagesize"],
              "showpg":showpg,
              "totalnumber": 1,
              "storegoodsbarcode": storegoodsbarcode,
              "goodsbarcode": goodsbarcode,
              "R/L": controlData.billmap[i]["R/L"],
              "id": index
            });
            index = index + 1;
          }
        }

        if(!this.supplytaskid){
          this.dmscode='zyanjingQRCode';//使用找眼镜网生成的条码
          this.loading=false;
          if(this.issale){
            this.$nextTick(() => {
              this.$refs.inputScan.focus();
            })
          }
          return;
        }

        if(this.supplytaskid=='essilordzcangku') {//定制片通知仓库的模式，不需要提交到依视路
          this.dmscode = 'essilordzcangku';
          this.loading = false;
          return;
        }
        //取依视路传过来的唯一码
        getGoBack({taskid: controlData.supplytaskid}).then(response => {
          if (response.data.code == 0) {
            var back = response.data.obj;
            if (back) {
              this.posttxt = JSON.parse(back.posttxt)
              this.ordertype = this.posttxt.Head.OrderType;

              //批量推送唯一码
              // this.importFrombuy();

              if(!back.backtxt){
                this.dmscode=controlData.tracknum;
                if(this.dmscode){
                  this.loading = false;
                }
                return;
              }
              this.supplyBack = back;
              var backT = JSON.parse(back.backtxt);
              this.dmscode = backT.DMSPlusNumber;
              if(!this.dmscode)
                this.dmscode=controlData.tracknum;
              if (this.ordertype == 'GeneralOrder') {//数量类型订单  不用扫码
                this.saveData();
                return;
              }
              if (this.ordertype == 'PieceLensOrder' || !backT.TrackingNumber) {//零星片,
                var backItem = backT.Items || backT.items;
                if (backItem) {
                  this.LogisticCode(JSON.parse(backItem), scancodes);
                }
              } else {
                if(this.noscan)//不需要唯一码的（只扫商品码）
                {
                  this.loading = false;
                  return;
                }

                //批量片：直接从依视路系统里取
                getLogisticCode({
                  dmsplusnumber: backT.DMSPlusNumber,
                  pcustomerserial: this.pcustomerserial
                }).then(response => {
                  this.LogisticCode(response.data.obj.Items, scancodes);
                });
              }
            }
          }
          this.loading = false;
        });
      },
      LogisticCode(backList,scancodes) {
        //"[{"LineNo": 1, "ProductCode": "943100A411-C","OpcCode":"", "Quantity": 2, "EYE": "", "SPH": "-0.50", "CYL": "0.00", "ADD": "", "AXIS": "0", "Side": "Left", "Lens": [{"LogisticCode": "WSo0067915104101416"}, {"LogisticCode": "WSo0067915004101416"}]}, {"LineNo": 2, "ProductCode": "943100A411-C", "Quantity": 1, "EYE": "", "SPH": "-1.25", "CYL": "0.00", "ADD": "", "AXIS": "0", "Side": "Left", "Lens": [{"LogisticCode": "WSo0067914804101416"}]}, {"LineNo": 3, "ProductCode": "943100A411-C", "Quantity": 2, "EYE": "", "SPH": "-0.25", "CYL": "0.00", "ADD": "", "AXIS": "0", "Side": "Right", "Lens": [{"LogisticCode": "WSo0067914704101416"}, {"LogisticCode": "WSo0067914604101416"}]}, {"LineNo": 4, "ProductCode": "943100A411-C", "Quantity": 1, "EYE": "", "SPH": "-0.75", "CYL": "0.00", "ADD": "", "AXIS": "0", "Side": "Right", "Lens": [{"LogisticCode": "WSo0067914504101416"}]}, {"LineNo": 5, "ProductCode": "943100A411-C", "Quantity": 3, "EYE": "", "SPH": "-1.00", "CYL": "0.00", "ADD": "", "AXIS": "0", "Side": "Right", "Lens": [{"LogisticCode": "WSo0067914304101416"}, {"LogisticCode": "WSo0067914204101416"}, {"LogisticCode": "WSo0067914104101416"}]}]"
        var lines = [];
        //先拆分成单条Code

        for (let i in backList) {
          if (this.noscan) {
            for (var j = 0; j < backList[i].Quantity; j++) {
              lines.push({
                EYE: backList[i].EYE,
                SPH: backList[i].SPH,
                CYL: backList[i].CYL,
                Side: backList[i].Side,
                OpcCode: backList[i].OpcCode ? backList[i].OpcCode : '',
                Code: 1
              })
            }
          } else {
            var items = '';
            try {
              items = JSON.parse(backList[i].Lens)
            } catch (ex) {
              items = backList[i].Lens
            }
            for (let j in items) {
              lines.push({
                EYE: backList[i].EYE,
                SPH: backList[i].SPH,
                CYL: backList[i].CYL,
                Side: backList[i].Side,
                OpcCode: backList[i].OpcCode ? backList[i].OpcCode : '',
                Code: items[j].LogisticCode
              })
            }
          }
        }

        for (let i in lines) {
          var rows = lines[i];

          var hasValue = false;
          for (let j in scancodes) {
            if (scancodes[j].storegoodsbarcode)//有编码的继续
              continue;

            var packageSize = JSON.parse(scancodes[j].packagesize);
            if (packageSize.type) {//存在左右眼区分的
              var type = packageSize.type == 'R' ? 'Right' : 'Left';
              if (parseFloat(packageSize.X) == parseFloat(rows.CYL) &&
                parseFloat(packageSize.Y) == parseFloat(rows.SPH) &&
                ((rows.EYE && (type == rows.EYE || packageSize.type == rows.EYE)) || (rows.Side && type == rows.Side || packageSize.type == rows.Side))) {
                scancodes[j].goodsbarcode = rows.OpcCode;
                scancodes[j].storegoodsbarcode = rows.Code;
                hasValue = true
                break;
              }
            } else {
              // 零星单 区分左右眼  是通过 eye 字段
              // 批量单  区分左右眼  是通过 side 字段
              if (scancodes[j]["R/L"]) {
                var type = scancodes[j]["R/L"] == 'R' ? 'Right' : 'Left';
                if (parseFloat(packageSize.X) == parseFloat(rows.CYL) &&
                  parseFloat(packageSize.Y) == parseFloat(rows.SPH) &&
                  ((rows.EYE && (type == rows.EYE || scancodes[j]["R/L"] == rows.EYE)) || (rows.Side && type == rows.Side || scancodes[j]["R/L"] == rows.Side))) {
                  scancodes[j].goodsbarcode = rows.OpcCode;
                  scancodes[j].storegoodsbarcode = rows.Code;
                  hasValue = true
                  break;
                }
              }
            }
          }

          if (!hasValue) {//未匹配到，只根据光度
            for (let j in scancodes) {
              if (scancodes[j].storegoodsbarcode)//有编码的继续
                continue;

              var packageSize = JSON.parse(scancodes[j].packagesize);
              if (parseFloat(packageSize.X) == parseFloat(rows.CYL) &&
                parseFloat(packageSize.Y) == parseFloat(rows.SPH)) {
                if (this.ordertype == 'PieceLensOrder' && !scancodes[j]["R/L"]) {//必须要有左右眼
                  scancodes[j]["R/L"] = rows.EYE;
                }
                scancodes[j].goodsbarcode = rows.OpcCode;
                scancodes[j].storegoodsbarcode = rows.Code;
                break;
              }
            }
          }

        }

        if (this.ordertype == 'PieceLensOrder') {
          for (let p in this.posttxt.Items) {
            for (let j in scancodes) {
              if (!scancodes[j]["R/L"]) {
                var rows = this.posttxt.Items[p].ItemExtend;
                var packageSize = JSON.parse(scancodes[j].packagesize);
                if (parseFloat(packageSize.X) == parseFloat(rows.Cylinder) &&
                  parseFloat(packageSize.Y) == parseFloat(rows.Sphere)) {
                  scancodes[j]["R/L"] = rows.LensSide == 'Right' ? 'R' : 'L';
                  break;
                }
              }
            }
          }
        }
      },
      //回车跳入下一行  上下方向键
      validateCounts(row, index, e) {
        setTimeout(() => {
          var keyCode = e.keyCode || e.which || e.charCode;
          if (keyCode == 40 || keyCode === 13) {//回车，下方向键
            this.$refs[row.id].blur()
            if (this.scancodes.length - 1 === index) {
              index = -1
            }
            this.$refs[Object.keys(this.$refs)[index + 1]].focus();
          } else if (keyCode == 38) {//上方向键
            this.$refs[row.id].blur()
            if (index === 0) {
              index = this.scancodes.length
            }
            this.$refs[Object.keys(this.$refs)[index - 1]].focus();
          }
        }, 100)
      },
      //给scancodes 添加 id，共回车使用
      indexMethod(index) {
        this.scancodes[index].id = index
        return index + 1;
      },
      setTimeZero(value) {
        return value > 9 ? value : '0' + value;
      },
      formatDate(date) {
        if (!date)
          return '';
        var myDate = new Date(date);
        return this.setTimeZero(myDate.getFullYear()) + '-'+(this.setTimeZero(myDate.getMonth() + 1)) + '-' + this.setTimeZero(myDate.getDate());
      }
    },
    mounted() {
    },
    components: {
      OrderBuyList
    }
  }
</script>


<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/ScanCodeSupplyer.vue